fragment CrossSellFragment on crossSell_Entry {
  heading
  overline
  pickystoryDealType
  showComparePrices
  triggerProductOverwrite
  typeHandle
  useProductOverwrite
  agreementCategory {
    ... on preAssessment_Entry {
      title
      agreementBody
      agreementLabel
      disagreementLabel
      confirmButtonLabel
      cancelButtonLabel
    }
  }
}
